import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findPoints = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points?`+params,
        method: 'GET'
    })
}

export const awardAndPunish = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/points/awardAndPunish`,
        method: 'PUT',
        data: data
    })
}
